export default "https://cdn-static.gokick.com/assets/9df01a4d731a00226137dd4d749df43ffc1d6e8e/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";